import { Button, Popup } from '@quickmd-llc/design-system'
import {
  DELETE_SERVICE_TYPE,
  DELETE_SERVICE_TYPE_POPUP_MESSAGE_TEXT,
  INTAKE_FORMS_CANCEL_BTN_TEXT,
} from '../../../../utils/constants'

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

/**
 * Confirmation popup for deleting the whole service type.
 *
 * SCSS → Tailwind: .vs-delete-popup-footer -> flex justify-end gap-sp-1 (8px).
 */
export const DeleteServiceTypePopup = ({ isOpen, onClose, onConfirm }: Props) => (
  <Popup
    isOpen={isOpen}
    header={DELETE_SERVICE_TYPE}
    body={<span>{DELETE_SERVICE_TYPE_POPUP_MESSAGE_TEXT}</span>}
    footer={
      <div className='flex justify-end gap-sp-1'>
        <Button priority='secondary' onClick={onClose}>
          {INTAKE_FORMS_CANCEL_BTN_TEXT}
        </Button>
        <Button priority='primary' theme='danger' onClick={onConfirm}>
          Delete
        </Button>
      </div>
    }
    onClose={onClose}
  />
)
